import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { ParFormFieldComponent } from '@shared/ui';

import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';

@Component({
  selector: 'dynamic-form-radio-control',
  templateUrl: 'radio-control.component.html',
  styleUrls: ['radio-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ParFormFieldComponent],
  providers: [
    { provide: DynamicFormControlDirective, useExisting: DynamicFormRadioControlComponent },
  ],
})
export class DynamicFormRadioControlComponent extends AbstractDynamicFormControl {}
